const version = '1.7.7'
const commit = `${process.env.COMMIT_HASH ? process.env.COMMIT_HASH : ''}`

function getProjectName() {
  const platform = process.env.PLATFORM ?? 'olymp'
  const isWebview = process.env.WEBVIEW === '1'
  const isSportBuild = process.env.OWN_SPORT

  let projectName = platform

  if (isWebview) {
    projectName += '-webview'
  }
  if (isSportBuild) {
    projectName += '-sport'
  }
  return projectName
}

function getRelease() {
  return `${version}@${commit}`
}

module.exports = {
  version,
  commit,
  getProjectName,
  getRelease,
}
